// This file has been deprecated in favor of core.js
var hljs = require('./core');
